import { render, staticRenderFns } from "./GenerateAccessToken.vue?vue&type=template&id=9fb3f446&scoped=true&"
import script from "./GenerateAccessToken.vue?vue&type=script&lang=ts&"
export * from "./GenerateAccessToken.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateAccessToken.vue?vue&type=style&index=0&id=9fb3f446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb3f446",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fb3f446')) {
      api.createRecord('9fb3f446', component.options)
    } else {
      api.reload('9fb3f446', component.options)
    }
    module.hot.accept("./GenerateAccessToken.vue?vue&type=template&id=9fb3f446&scoped=true&", function () {
      api.rerender('9fb3f446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/GenerateAccessToken.vue"
export default component.exports